import { render } from "./WorkspaceContainer.vue?vue&type=template&id=747d20d5&scoped=true&ts=true"
import script from "./WorkspaceContainer.vue?vue&type=script&lang=ts"
export * from "./WorkspaceContainer.vue?vue&type=script&lang=ts"

import "./WorkspaceContainer.vue?vue&type=style&index=0&id=747d20d5&scoped=true&lang=scss"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747d20d5"]])

export default __exports__